import { render } from "./LiveSessions.vue?vue&type=template&id=37166e7c"
import script from "./LiveSessions.vue?vue&type=script&lang=js"
export * from "./LiveSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__